import React from 'react';
import { useState, Fragment } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import CopyToClipboard from 'react-copy-to-clipboard';

import { Typography, Button, Box, TextField } from '@mui/material';
import { supabase } from '../../../api';
import { PROFILE_TABLE } from '../../../constants/supabase_constants';

const StepIntroduction = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [introduction, setIntroduction] = useState(null);
  const [disabled, setDisabled] = useState(true);

  const messageTemplate = (hello, background, reason, working, assist1) => {
    return `

**I’m a new mentor for The 100 Club!**

**${hello}**

**My background:**
${background}

**Why I’m here:**
${reason}

**What I’m working on:**
${working}

**What can I assist with:**
${assist1}`;
  };

  const updateProfile = async () => {
    try {
      const user = supabase.auth.user();

      const updates = {
        id: user.id,
        mentorIntroduction: messageTemplate(
          formik.values.hello,
          formik.values.background,
          formik.values.reason,
          formik.values.working,
          formik.values.assist1,
        ),
        updated_at: new Date(),
      };

      let { error } = await supabase.from(PROFILE_TABLE).upsert(updates, {
        returning: 'minimal', // Don't return the value after inserting
      });

      if (error) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
    }
  };

  const validationSchema = yup.object({
    hello: yup.string('Say hello'),
    background: yup.string('Share your background'),
    reason: yup.string('Share your reason for joining'),
    working: yup.string("Share what you're working on"),
    assist1: yup.string('Share how you can help'),
  });

  const formik = useFormik({
    initialValues: {
      introduction: introduction,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      updateProfile();
      props.handleNext();
    },
  });

  return (
    <Fragment>
      <Fragment>
        <Typography variant='h4' sx={{ mt: '3rem', mb: 1, fontWeight: 'bold' }}>
          Last step - let's help you prepare your introduction.
        </Typography>
        <Typography variant='body1' sx={{ mb: '2rem' }}>
          Fill in the blanks accordingly, copy to clipboard, and send it into our telegram community once you join!
        </Typography>
        <form onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            id='hello'
            name='hello'
            label="How would you say hello to everyone? (Eg. Hi, I'm Sean!)"
            type='hello'
            sx={{
              mb: '1.5rem',
            }}
            value={formik.values.hello}
            onChange={formik.handleChange}
            error={formik.touched.hello && Boolean(formik.errors.hello)}
            helperText={formik.touched.hello && formik.errors.hello}
          />
          <TextField
            fullWidth
            multiline
            rows={3}
            id='background'
            name='background'
            label='What’s your background?'
            type='background'
            sx={{
              mb: '1.5rem',
            }}
            value={formik.values.background}
            onChange={formik.handleChange}
            error={formik.touched.background && Boolean(formik.errors.background)}
            helperText={formik.touched.background && formik.errors.background}
          />
          <TextField
            fullWidth
            multiline
            rows={3}
            id='reason'
            name='reason'
            label='Why are you in The 100 club?'
            type='reason'
            sx={{
              mb: '1.5rem',
            }}
            value={formik.values.reason}
            onChange={formik.handleChange}
            error={formik.touched.reason && Boolean(formik.errors.reason)}
            helperText={formik.touched.reason && formik.errors.reason}
          />
          <TextField
            fullWidth
            id='working'
            name='working'
            label='What are you currently working on?'
            type='working'
            sx={{
              mb: '1.5rem',
            }}
            value={formik.values.working}
            onChange={formik.handleChange}
            error={formik.touched.working && Boolean(formik.errors.working)}
            helperText={formik.touched.working && formik.errors.working}
          />
          <TextField
            fullWidth
            id='assist1'
            name='assist1'
            label='What can you assist others with?'
            type='assist1'
            sx={{
              mb: '1.5rem',
            }}
            value={formik.values.assist1}
            onChange={formik.handleChange}
            error={formik.touched.assist1 && Boolean(formik.errors.assist1)}
            helperText={formik.touched.assist1 && formik.errors.assist1}
          />
          <CopyToClipboard
            text={messageTemplate(
              formik.values.hello,
              formik.values.background,
              formik.values.reason,
              formik.values.working,
              formik.values.assist1,
            )}>
            <Button
              color='primary'
              variant='contained'
              fullWidth
              sx={{ mt: '1rem' }}
              onClick={(e) => {
                setDisabled(false);
                alert(
                  'Message copied to clipboard. Send it in the #introductions Telegram topic at the end of the onboarding process!',
                );
              }}>
              Copy to clipboard
            </Button>
          </CopyToClipboard>

          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button type='submit' disabled={disabled}>
              Next
            </Button>
          </Box>
        </form>
      </Fragment>
    </Fragment>
  );
};

export default StepIntroduction;
